import controller from './oo-admin-objects-list.controller';
import template from './oo-admin-objects-list.html';

export default {
	bindings:     {
		classKid:    '<',
	},
	controller,
	template,
	controllerAs: '$ctrl',
	require:      {
		parent: '^^ooAdmin',
	},
};
